import { useState, useEffect } from 'react';
import { useTranslation } from "react-i18next";
import Header from "../global/header";
import Footer from "../global/footer";
import Title from './Title/Title';
import Language from './Language/Langauge';

import Form from 'react-bootstrap/Form';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';
import '../styles/home.css';
import { isOnlyAlphaAndNumericValid, objectIsEmpty } from '../utils/validAndTest';
import tokenService from '../service/token.service';
import apiService from '../service/api.service';

const Home = () => {

  const { t } = useTranslation();

  const [userInfo, setUserInfo] = useState({
    socialMediaName: '',
    firstName: '',
    lastName: '',
    email: '',
  });

  const [userInfoErr, setUserInfoErr] = useState({
    firstName: '',
    lastName: '',
  });

  const [validated, setValidated] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleChange = (event) => {
    const key = event.target.name;
    const value = event.target.value;
  
    if (value) {
      setUserInfo({ ...userInfo, [key]: value });
      const isValid = isOnlyAlphaAndNumericValid(value);
      handleUserInfoErr(key, isValid ? '' : 'TEXT_FORM_FIELD_NAME_NOT_VALID');
    } else {
      setUserInfo({ ...userInfo, [key]: value });

      var errMessage= "";
      if(key==='firstName'){
        errMessage= 'TEXT_FORM_FIRST_NAME_NOT_EXIST'
      }else if(key==='lastName') {
        errMessage= 'TEXT_FORM_LAST_NAME_NOT_EXIST'
      }

      handleUserInfoErr(key, errMessage);
    }
  };

  const handleUserInfoErr = (key, value) => {
    setUserInfoErr({ ...userInfoErr, [key]: value });
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setLoading(true);

    const fieldErrorData = {};
    const { firstName, lastName } = userInfo;
  
    if (!firstName) {
      fieldErrorData.firstName = 'TEXT_FORM_FIRST_NAME_NOT_EXIST';
    }
  
    if (!lastName) {
      fieldErrorData.lastName = 'TEXT_FORM_LAST_NAME_NOT_EXIST';
    }
  
    if (!objectIsEmpty(fieldErrorData)) {      
      setUserInfoErr(fieldErrorData);
      setValidated(true);
      setLoading(false);
      return;
    }
  
    setValidated(false);
    let isFormSubmission = true;
    apiService.validateUserData(userInfo, isFormSubmission);
  };

  const isSubmitEnable = () => {
    let isEnable =  ((userInfoErr.firstName || userInfoErr.lastName) || loading)
    return isEnable;
  }

  useEffect(() => {
    var decodedUser = tokenService.getUserInfo();
  
    if (!decodedUser) return;
    try {
      setUserInfo({
        socialMediaName: decodedUser?.socialMediaName,
        firstName: decodedUser?.firstName,
        lastName: decodedUser?.lastName,
        email: decodedUser?.email,
      });
      const fieldErrorData = {};
      const fieldsToValidate = ['firstName', 'lastName'];

      fieldsToValidate.forEach(fieldName => {
        if (!isOnlyAlphaAndNumericValid(decodedUser[fieldName])) {
          fieldErrorData[fieldName] = 'TEXT_FORM_FIELD_NAME_NOT_VALID';
        }
      });

      if (!objectIsEmpty(fieldErrorData)) {
        setUserInfoErr(fieldErrorData);
      }
    } catch (error) {
      throw new Error(error);
    }
  
  }, []);

  return (
    <>
      <Header />
      <Container>
        <Row>
          <Col lg="1" />
          <Col lg="10" className="middlePadding">
            <div>
              <Title logoType="Success"> {t('TEXT_HOME_PAGE_TITLE')} </Title>
              <Language />
            </div>
            <div>
              <Card className="card contentCard" text="white">
                <Card.Body>
                  <Card.Title className="cardTitle">{t('TEXT_FORM_ERROR_CONTENT_TITLE')}</Card.Title>
                  <Card.Text>
                    <ul className="cardUl">
                      <li>{t('TEXT_FORM_ERROR_INSTRUCTION_1')}</li>
                      <li>{t('TEXT_FORM_ERROR_INSTRUCTION_2')}</li>
                      <li>{t('TEXT_FORM_ERROR_INSTRUCTION_3')}</li>
                    </ul>
                  </Card.Text>
                </Card.Body>
              </Card>
            </div>
            <Form noValidate validated={validated} className="mb-3">
              {
                userInfo.socialMediaName &&
                <Form.Group className="mb-32" controlId="formGroupSocialMediaName">
                  <Form.Label>{t('LABEL_FORM_FIELD_SOCIAL_MEDIA_NAME')}</Form.Label>
                  <Form.Control 
                    type="text" 
                    placeholder={t('TEXT_FORM_FIELD_SOCIAL_MEDIA_NAME_PLACEHOLDER')} 
                    onChange={handleChange} 
                    value={userInfo.socialMediaName} 
                    name="socialMediaName"
                    required
                    disabled
                  />
                </Form.Group>
              }
              <Form.Group className="mb-32" controlId="formGroupFirstName">
                <Form.Label>{t('LABEL_FORM_FIELD_FIRST_NAME')} <span className="text-danger"> * </span></Form.Label>
                <Form.Control 
                  type="text" 
                  placeholder={t('TEXT_FORM_FIELD_FIRST_NAME_PLACEHOLDER')} 
                  onChange={handleChange} 
                  value={userInfo.firstName} 
                  name="firstName" 
                  isInvalid={userInfoErr.firstName}
                  maxLength={60}
                  aria-required
                  aria-invalid={userInfoErr.firstName ? true : false}
                />
                <Form.Control.Feedback type="invalid" className="errorMessage">
                  {t(userInfoErr.firstName)}
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group className="mb-32" controlId="formGroupLastName">
                <Form.Label>{t('LABEL_FORM_FIELD_LAST_NAME')} <span className="text-danger"> * </span> </Form.Label> 
                <Form.Control 
                  type="text"
                  placeholder={t('TEXT_FORM_FIELD_LAST_NAME_PLACEHOLDER')} 
                  value={userInfo.lastName} 
                  onChange={handleChange} 
                  name="lastName" 
                  isInvalid={userInfoErr.lastName}
                  maxLength={60}
                  aria-required
                  aria-invalid={userInfoErr.lastName ? true : false}
                />
                <Form.Control.Feedback type="invalid" className="errorMessage">
                  {t(userInfoErr.lastName)}
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group className="mb-32" controlId="formGroupEmail">
                <Form.Label>{t('LABEL_FORM_FIELD_EMAIL')}</Form.Label>
                <Form.Control
                  type="email"
                  value={userInfo.email}
                  placeholder={t('TEXT_FORM_FIELD_EMAIL_PLACEHOLDER')}
                  onChange={handleChange}
                  name="email"
                  required
                  disabled
                />
                <Form.Control.Feedback type="invalid" className="errorMessage">
                  {userInfoErr?.email}
                </Form.Control.Feedback>
              </Form.Group>
              <div className="d-grid gap-2">
                <Button
                  onClick={handleSubmit}
                  className="submitBtn"
                  disabled={isSubmitEnable()}
                >
                  {
                    loading ?
                    <Spinner animation="border" variant="light">
                      <span className="visually-hidden">{t('TEXT_LOADER')}</span>
                    </Spinner>
                    :
                    <span>{t('LABEL_FORM_SUBMIT_BUTTON')}</span>
                  }
                </Button>
              </div>
            </Form>
            <Footer />
          </Col>
          <Col lg="1" />
        </Row>
      </Container>
    </>
  );
}

export default Home;
